import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { sendFromMessages as messages } from './sendFromMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the setup; each part uses its own slice of it */
import styles from './Builder.module.scss';
/* eslint-enable css-modules/no-unused-class */

const CARDS = [
  { key: 'ramp', title: messages.whyRampTitle, body: messages.whyRamp },
  { key: 'replies', title: messages.whyRepliesTitle, body: messages.whyReplies },
  { key: 'team', title: messages.whyTeamTitle, body: messages.whyTeam },
];

/** The three facts under the mailbox card (design outreach-v2 e1 `why`). */
const SendFromWhyComponent: React.FC = () => {
  const intl = useIntl();
  const cards = useMemo(
    () =>
      CARDS.map((card) => (
        <div key={card.key} className={styles.whyCard}>
          <b>{intl.formatMessage(card.title)}</b>
          {intl.formatMessage(card.body)}
        </div>
      )),
    [intl]
  );
  return <div className={styles.why}>{cards}</div>;
};

export const SendFromWhy = TypedMemo(SendFromWhyComponent);
